import { createAction } from '@reduxjs/toolkit';

import {
    AccommodationItemModel,
    LocationDetailsModel,
    SearchCriteria,
    SearchFilters,
} from '@app/models';

/**
 * Initialize the map search state from URL parameters
 */
export const initMapSearchFromUrlAction = createAction<{
    searchCriteria: Partial<SearchCriteria>;
    filters: Partial<SearchFilters>;
}>('map-search/initFromUrl');

/**
 * Trigger fetching of map accommodations based on current search criteria
 */
export const fetchMapAccommodationsAction = createAction('map-search/fetchAccommodations');

/**
 * Update the search criteria (location, dates, guests)
 * @param shouldUpdateUrl Whether to update URL after updating state (default: false)
 */
export const updateSearchCriteriaAction = createAction<{
    criteria: Partial<SearchCriteria>;
    shouldUpdateUrl?: boolean;
}>('map-search/updateSearchCriteria');

/**
 * Update the filters (property types, amenities, etc.)
 * @param shouldUpdateUrl Whether to update URL after updating state (default: false)
 */
export const updateSearchFiltersAction = createAction<{
    filters: Partial<SearchFilters>;
    shouldUpdateUrl?: boolean;
}>('map-search/updateSearchFilters');

/**
 * Reset the search criteria to defaults
 */
export const resetSearchCriteriaAction = createAction('map-search/resetSearchCriteria');

/**
 * Reset the filters to defaults
 */
export const resetSearchFiltersAction = createAction('map-search/resetSearchFilters');

/**
 * Set the loading state for map search
 */
export const setMapSearchLoadingAction = createAction<boolean>('map-search/setLoading');

/**
 * Set selected accommodation
 */
export const setSelectedAccommodationAction = createAction<{
    accommodation: AccommodationItemModel | null;
}>('map-search/setSelectedAccommodation');

/**
 * Toggle filters visibility
 */
export const toggleFiltersVisibilityAction = createAction('map-search/toggleFiltersVisibility');

/**
 * Set filters visibility
 */
export const setFiltersVisibilityAction = createAction<{
    open: boolean;
}>('map-search/setFiltersVisibility');

/**
 * Set location details
 */
export const setLocationDetailsAction = createAction<{
    locationDetails: LocationDetailsModel | null;
}>('map-search/setLocationDetails');

/**
 * Set map loaded
 */
export const setIsMapLoadedAction = createAction<{
    isMapLoaded: boolean;
}>('map-search/setIsMapLoaded');
